import { render, staticRenderFns } from "./addHotelGroup.vue?vue&type=template&id=18aa5766&scoped=true"
import script from "./addHotelGroup.vue?vue&type=script&lang=js"
export * from "./addHotelGroup.vue?vue&type=script&lang=js"
import style0 from "./addHotelGroup.vue?vue&type=style&index=0&id=18aa5766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa5766",
  null
  
)

export default component.exports